// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-spinner {
    display: block;
    margin: 0 auto;
  }


  .error-message {
    color: red;
    font-size: 14px;
    margin-top: 10px;
  }
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkZC11cGRhdGUtaG9saWRheS1kaWFsb2cuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGNBQWM7SUFDZCxjQUFjO0VBQ2hCOzs7RUFHQTtJQUNFLFVBQVU7SUFDVixlQUFlO0lBQ2YsZ0JBQWdCO0VBQ2xCIiwiZmlsZSI6ImFkZC11cGRhdGUtaG9saWRheS1kaWFsb2cuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sb2FkaW5nLXNwaW5uZXIge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIG1hcmdpbjogMCBhdXRvO1xuICB9XG5cblxuICAuZXJyb3ItbWVzc2FnZSB7XG4gICAgY29sb3I6IHJlZDtcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgbWFyZ2luLXRvcDogMTBweDtcbiAgfSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/admin/holiday_list/add-update-holiday-dialog/add-update-holiday-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;EAChB;;;EAGA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;AACF,okBAAokB","sourcesContent":[".loading-spinner {\n    display: block;\n    margin: 0 auto;\n  }\n\n\n  .error-message {\n    color: red;\n    font-size: 14px;\n    margin-top: 10px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
